export default __webpack_public_path__ + "media/fonts/montserrat-semibold.ttf";